'use es6';

import styled from 'styled-components';
import ColorPickerPopoverBody from 'react-colorpicker/popover/ColorPickerPopoverBody';
import withFavoriteColors from 'rich-text-lib/components/hoc/withFavoriteColors';
import { getPluginSetting } from '../utils';
import { getEditLink } from '../hscolor/util';
import { getFetchFavoriteColors } from 'tinymce-data/api/Colors';
import { jsx as _jsx } from "react/jsx-runtime";
const ColorPicker = withFavoriteColors(ColorPickerPopoverBody);
const ColorPickerWrapper = styled.div.withConfig({
  displayName: "ColorPicker__ColorPickerWrapper",
  componentId: "qul6ti-0"
})(["width:300px;"]);
export const getColorPicker = (editor, colorPickerProps) => {
  const {
    scopes,
    apiClient,
    custom_colors: favorites
  } = editor.settings;
  const pickerProps = Object.assign({
    favorites,
    includeAlpha: !getPluginSetting(editor, 'isEmail'),
    editFavoritesLink: getEditLink(editor),
    showFavoritesLink: scopes && scopes.includes('settings-access'),
    showResetToDefault: true,
    fetchFavoriteColors: getFetchFavoriteColors(apiClient)
  }, colorPickerProps);
  function WrappedColorPicker(props) {
    return (
      /*#__PURE__*/
      // @bend-expect trellis-tokenized
      _jsx(ColorPickerWrapper, {
        children: /*#__PURE__*/_jsx(ColorPicker, Object.assign({}, pickerProps, props, {
          onMouseDown: evt => evt.preventDefault()
        }))
      })
    );
  }
  return WrappedColorPicker;
};